import { siteText } from '../siteText'
import { LoaderCircle, Trash2, Undo2, X } from 'lucide-react'
import { useEffect, useRef, type ComponentProps } from 'react'

export function DeleteButton({ label, busy = false, className = '', disabled, ...props }: ComponentProps<'button'> & { label: string; busy?: boolean }) {
  return <button
    type="button"
    className={`delete-button${className ? ` ${className}` : ''}`}
    aria-label={siteText(`Delete ${label}`)}
    title={siteText(`Delete ${label}`)}
    aria-busy={busy || undefined}
    disabled={busy || disabled}
    {...props}
  >
    {busy ? <LoaderCircle className="spin" size={14} aria-hidden="true" /> : <Trash2 size={14} strokeWidth={1.8} aria-hidden="true" />}
  </button>
}

export function UndoToast({ message, onUndo, onDismiss, busy = false }: { message: string; onUndo: () => void; onDismiss: () => void; busy?: boolean }) {
  const dismissRef = useRef(onDismiss)
  useEffect(() => { dismissRef.current = onDismiss }, [onDismiss])
  useEffect(() => {
    const timeout = window.setTimeout(() => dismissRef.current(), 8000)
    return () => window.clearTimeout(timeout)
  }, [message])

  return <div className="undo-toast" role="status" aria-live="polite">
    <span>{siteText(message)}</span>
    <button type="button" className="undo-toast-action" onClick={onUndo} disabled={busy}><Undo2 size={14} aria-hidden="true" /> Undo</button>
    <button type="button" className="undo-toast-dismiss" onClick={onDismiss} aria-label="Dismiss undo notification"><X size={13} aria-hidden="true" /></button>
  </div>
}
